module.exports = __webpack_public_path__ + "img/arrow-right-circle.bdbb0ef6.svg";